import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { CloseIcon, Edit1Icon } from 'tdesign-icons-react';
import { Button, Image } from 'tdesign-react';

import { Edit } from '@/components/icon';
import { MultiCharacter, ThumbnailType } from '@/interface/media';

import SpineWebPlayer from '../../core/player/spine';
import { ISpineResult } from '../../folder';
import CharacterDialog from '../dialog';
import styles from './index.module.less';

interface IProps {
  value: MultiCharacter[];
  disabled: boolean;
  thumbnail?: ThumbnailType;
  onChange: (value: MultiCharacter[]) => void;
}

// 多人立绘预览和编辑（横向长条形式）
const CharacterPreviewAndEdit: React.FC<IProps> = ({
  value,
  disabled,
  thumbnail,
  onChange,
}) => {
  const [visible, setVisible] = useState(false);

  const removePic = () => {
    onChange([]);
  };

  const openDialog = () => {
    setVisible(true);
  };

  const onSpineChange = (val: ISpineResult) => {
    onChange(value?.map(e => (e.id === val.id ? { ...e, spine: val } : e)));
  };

  const getPreviewDom = useCallback((e: MultiCharacter) => {
    if (e.spine) {
      const { id, thumbnail, directoryName } = e.spine;
      return <>
      {thumbnail ? (
        <Image
          key={`spine-${id}`}
          src={thumbnail}
          fit='contain'
          loading={''}
          error={''}
          className={styles.image}
        />
      ) : (
        <span key={`spine-${id}`} className={styles.name}>
          {directoryName || '未命名Spine'}
        </span>
      )}
        <div
          key={`spine-thumbnail-${e.id}`}
          style={{
            position: 'absolute',
            opacity: 0,
            width: '1px',
            height: '1px',
            overflow: 'hidden',
            pointerEvents: 'none',
            backgroundColor: 'transparent',
          }}>
          <SpineWebPlayer
            value={e.spine}
            disabled={disabled}
            config={{ width: '100px', height: '100px' }}
            onChange={onSpineChange}
          />
        </div>
      </>;
    }

    if (e.image) {
      const { id, url } = e.image;
      return (
        <Image
          key={`image-${id}`}
          src={url?.url}
          fit='contain'
          loading={''}
          error={''}
          className={styles.image}
        />
      );
    }

    return <div/>;
  }, [value]);

  return (
    <div className={styles.wrapper}>
      {value.length > 0
        ? <>
          <div className={styles.preview}
            onClick={openDialog}
          >
            {value?.map(e => (
              <React.Fragment key={e.id}>
                {getPreviewDom(e)}
              </React.Fragment>
            ))}
        </div>
        <div className={styles.opration}>
          <div className={styles.btnGroup}>
            <Button
                variant="text"
              icon={<Edit1Icon size={16} />}
                className={classNames(styles.opBtn, {
                  ['nova-disabled-opacity']: disabled,
                  ['nova-disabled']: disabled,
                })}
                disabled={disabled}
              onClick={openDialog}
            />
            <Button
                variant="text"
              icon={<CloseIcon size={16} />}
                className={classNames(styles.opBtn, {
                  ['nova-disabled-opacity']: disabled,
                  ['nova-disabled']: disabled,
                })}
              disabled={disabled}
              onClick={removePic}
            />
          </div>
        </div>
        </>
        : <div className={classNames(styles.empty, {
          ['nova-disabled-opacity']: disabled,
          ['nova-disabled']: disabled,
        })}
          onClick={openDialog}
        >
            <Edit />编辑立绘
          </div>}

      <CharacterDialog
        visible={visible}
        value={value}
        disabled={disabled}
        thumbnail={thumbnail}
        onChange={onChange}
        onClose={() => setVisible(false)}
      />
    </div>
  );
};

export default CharacterPreviewAndEdit;
